import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HotToastService } from '@ngxpert/hot-toast';
import { TranslateService } from '@ngx-translate/core';
import { CredentialsService } from '../../auth/services/credentials.service';

@Injectable({
  providedIn: 'root',
})
export class SessionDeletionService {
  private readonly _credentialsService = inject(CredentialsService);
  private readonly _router = inject(Router);
  private readonly _toastService = inject(HotToastService);
  private readonly _translateService = inject(TranslateService);

  private _handlingDeletion = false;

  checkCurrentSession(): boolean {
    const credentials = this._credentialsService.credentials;
    const isDeleted = !!credentials && (credentials.deletedUser || Number((credentials as any).deleted_user) === 1);

    if (!credentials || !isDeleted) {
      return false;
    }

    this.handleDeletedSession();
    return true;
  }

  handleDeletedSession(): void {
    if (this._handlingDeletion) {
      return;
    }

    this._handlingDeletion = true;

    this._toastService.error(this._translateService.instant('Your account has been deleted. Please contact support. Logging out...'), {
      duration: 6000,
    });

    setTimeout(() => {
      this._router.navigate(['/logout']);
    }, 4000);
  }
}
